import { render, staticRenderFns } from "./CompanyExportModal.vue?vue&type=template&id=2f7979f6&scoped=true&"
import script from "./CompanyExportModal.vue?vue&type=script&lang=ts&"
export * from "./CompanyExportModal.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyExportModal.vue?vue&type=style&index=0&id=2f7979f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7979f6",
  null
  
)

export default component.exports